module.exports = __webpack_public_path__ + "static/calloutReports-9db61cea096e8c1a2f71981fe7f6651f.jpg";